import { Typography } from '@mui/material';
import { dateFormatters } from '@utils/formattersV2';

type SalesDataRefreshedProps = {
  reportDate: Date;
};

export const SalesDataRefreshed = (props: SalesDataRefreshedProps) => (
  <Typography textAlign="right">
    Sales Data refreshed on {dateFormatters.shortLocaleString(props.reportDate)}
  </Typography>
);
